export default "__VITE_ASSET__bIh0aIGD__"